import { create } from "zustand";

interface ChatState {
  panelOpen: boolean;
  pendingOpenConvId: string | null;

  openPanel: () => void;
  closePanel: () => void;
  togglePanel: () => void;
  setPendingOpenConvId: (id: string | null) => void;
}

export const useChatStore = create<ChatState>((set) => ({
  panelOpen: false,
  pendingOpenConvId: null,

  openPanel: () => set({ panelOpen: true }),
  closePanel: () => set({ panelOpen: false }),
  togglePanel: () => set((s) => ({ panelOpen: !s.panelOpen })),
  setPendingOpenConvId: (id) => set({ pendingOpenConvId: id }),
}));
